import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    if (status === 401) {
      const path = window.location.pathname;
      if (path !== "/login") {
        localStorage.removeItem("token");
        // soft reload to login
        window.dispatchEvent(new CustomEvent("auth:logout"));
      }
    }
    if (status === 402) {
      // Subscription required — redirect to billing page (unless we're already there
      // or fetching the billing/me record itself)
      const path = window.location.pathname;
      const isBillingApi = err?.config?.url?.includes("/billing/");
      if (path !== "/billing" && !isBillingApi) {
        window.location.replace("/billing");
      }
    }
    if (status === 403) {
      // Plan-tier feature gate — surface the global Upgrade modal so admins
      // can change plan without leaving the app.
      const detail = err?.response?.data?.detail;
      const code = detail && typeof detail === "object" ? detail.code : null;
      if (code === "feature_not_in_plan" || code === "user_limit_reached") {
        window.dispatchEvent(
          new CustomEvent("billing:upgrade-needed", {
            detail: {
              reason: code,
              message: detail.message,
            },
          })
        );
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
